import type { RiskObjectGroups, ROBoatMinimal } from '../types';

const GROUPS: RiskObjectGroups<ROBoatMinimal> = [
  {
    title: 'RO_SECTION_OVERVIEW',
    properties: [
      {
        label: 'RO_BOAT_NAME',
        getValue: (boat) => boat.name,
      },
      {
        label: 'RO_BOAT_BRAND',
        getValue: (boat) => boat.brand,
      },
      {
        label: 'RO_BOAT_TYPE',
        getValue: (boat) => boat.type,
      },
      // {
      //   label: 'RO_BOAT_MODEL_YEAR',
      //   getValue: (boat) => boat.model_year,
      // },
      // {
      //   label: 'RO_BOAT_CATEGORY',
      //   getValue: (boat) => i18n.t(`BOAT_CATEGORY_${boat.category}`),
      // },
      // {
      //   label: 'RO_BOAT_HAS_CABIN',
      //   getValue: (boat) =>
      //     boat.has_cabin !== undefined && yesNo(boat.has_cabin),
      // },
    ],
  },
  {
    title: 'RO_SECTION_DIMENSIONS',
    properties: [
      // {
      //   label: 'RO_BOAT_LENGTH',
      //   getValue: (boat) => `${boat.length}${boat.length_unit ?? 'm'}`,
      // },
      // {
      //   label: 'RO_BOAT_BEAM',
      //   getValue: (boat) => `${boat.beam}m`,
      // },
      // {
      //   label: 'RO_BOAT_DRAFT',
      //   getValue: (boat) => `${boat.draft}m`,
      // },
      // {
      //   label: 'RO_BOAT_WEIGHT',
      //   getValue: (boat) => `${boat.weight}kg`,
      // },
      // {
      //   label: 'RO_BOAT_CONSTRUCTION',
      //   getValue: (boat) =>
      //     i18n.t(`BOAT_CONSTRUCTION_${boat.construction_type}`),
      // },
    ],
  },
  {
    title: 'RO_SECTION_MOTOR',
    properties: [
      // {
      //   label: 'RO_BOAT_MOTOR_KIND',
      //   getValue: (boat) => i18n.t(`BOAT_MOTOR_${boat.motor_kind}`),
      // },
      // {
      //   label: 'RO_BOAT_MOTOR_COUNT',
      //   getValue: (boat) => boat.amount_of_motors,
      // },
      // {
      //   label: 'RO_BOAT_MOTOR_BRAND',
      //   getValue: (boat) => boat.motor_brand,
      // },
      // {
      //   label: 'RO_BOAT_FUEL',
      //   getValue: (boat) => i18n.t(`FUEL_TYPE_${boat.fuel}`),
      // },
      // {
      //   label: 'RO_BOAT_POWER',
      //   getValue: (boat) => `${boat.hp}pk`,
      // },
      // {
      //   label: 'RO_BOAT_TOP_SPEED',
      //   getValue: (boat) => `${boat.top_speed_km_per_hour}km/h`,
      // },
    ],
  },
  {
    title: 'RO_SECTION_USAGE',
    properties: [
      // {
      //   label: 'RO_BOAT_USAGE',
      //   getValue: (boat) => i18n.t(`BOAT_USAGE_${boat.usage}`),
      // },
      // {
      //   label: 'RO_BOAT_TERRITORY',
      //   getValue: (boat) => i18n.t(`BOAT_TERRITORY_${boat.territory}`),
      // },
      // {
      //   label: 'RO_BOAT_BERTH',
      //   getValue: (boat) => i18n.t(`BOAT_BERTH_${boat.berth}`),
      // },
      // {
      //   label: 'RO_BOAT_COMPETITION',
      //   getValue: (boat) =>
      //     boat.used_in_competition !== undefined &&
      //     yesNo(boat.used_in_competition),
      // },
      // {
      //   label: 'RO_BOAT_VALUE',
      //   getValue: (boat) => formatCurrency(boat.daily_value),
      // },
      // {
      //   label: 'RO_BOAT_TRACK_AND_TRACE',
      //   getValue: (boat) =>
      //     boat.has_track_and_trace_system !== undefined &&
      //     yesNo(boat.has_track_and_trace_system),
      // },
    ],
  },
  {
    title: 'RO_SECTION_REGISTRATION',
    properties: [
      // {
      //   label: 'RO_BOAT_REGISTRATION_NUMBER',
      //   getValue: (boat) => boat.registration_number,
      // },
      // {
      //   label: 'RO_BOAT_WIN_NUMBER',
      //   getValue: (boat) => boat.win_number,
      // },
      // {
      //   label: 'RO_BOAT_IS_REGISTERED',
      //   getValue: (boat) =>
      //     boat.is_registered !== undefined && yesNo(boat.is_registered),
      // },
      // {
      //   label: 'RO_BOAT_COUNTRY',
      //   getValue: (boat) => boat.country_of_registration,
      // },
    ],
  },
];

export default GROUPS;
